import { WithTooltip } from "components/blocks/WithTooltip";
import { COLORS } from "styles/colors";
import { Text } from "components/atoms/text/Text";
import { PiFileArrowDown } from "react-icons/pi";
import { IoMdDownload } from "react-icons/io";
import { HelpGuide } from "hook/useHelpGuideApi";
import { downloadFromUrl } from "utils/functions";

interface TableListItemProps {
  guide: HelpGuide;
  showAtTop?: boolean;
}

const ListItemEtc = ({ guide, showAtTop }: TableListItemProps) => {
  return (
    <tr>
      <td className="file-type">
        <PiFileArrowDown />
      </td>
      <td className="title">
        <Text>{guide.title}</Text>
      </td>
      <td className="description">
        <Text color={COLORS.BUTTONS1} fontSize={14}>
          {guide.description}
        </Text>
      </td>
      <td>
        <div className="actions">
          <span></span>
          <span></span>
          <WithTooltip tooltip="Download" showAtTop={showAtTop}>
            <button
              onClick={() =>
                downloadFromUrl(guide.resourceUrl, guide.fileName ?? "")
              }
              data-testid="help-video-guides-item-button-download-from-url"
            >
              <IoMdDownload />
            </button>
          </WithTooltip>
        </div>
      </td>
    </tr>
  );
};

export default ListItemEtc;
